import PropTypes from 'prop-types'
import React from 'react'
import focusable from '../../components/Focusable/Focusable'
import { noOp } from '../../../../shared/helpers'

class FocusableDiv extends React.PureComponent {
  constructor(props) {
    super(props)

    this.componentType = props.componentType
    this.focusableDivRef = React.createRef()
  }

  onKeyEvent(key) {
    let handled = false
    if (this.focusableDivRef.current) {
      if ('ENTER' === key) {
        this.focusableDivRef.current?.click()
      }
      if ('BACK' === key) {
        this.focusableDivRef.current?.click()
      }
    }
    return handled
  }

  render() {
    const { hasFocus, onClick } = this.props
    return (
      <div
        className={
          this.props.className + ` ${hasFocus ? 'active' : 'inactive'}`
        }
        ref={this.focusableDivRef}
        onClick={onClick}
      >
        {this.props.children}
      </div>
    )
  }
}

FocusableDiv.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.object,
  ]),
  componentType: PropTypes.string,
  hasFocus: PropTypes.bool,
  onClick: PropTypes.func,
}

FocusableDiv.defaultProps = {
  children: null,
  onClick: noOp,
  className: '',
  hasFocus: false,
  componentType: '',
}

export default focusable(FocusableDiv)
